import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, any } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { PaquetesFleteImportes, paqueteToString } from "./paquetes";

export interface CotizacionConcepto {
    cantidad?: number;
    titulo: string;
    importe: number;
}

export interface CotizacionGrupo {
    titulo: string;
    conceptos: CotizacionConcepto[];
}

export interface Cotizacion {
    grupos: CotizacionGrupo[];
    descuentoFlete: number;
    flete: number;
    subtotal: number;
    iva: number;
    retencionIva: number;
    total: number;
}


export function obtenerFletes(paquetes: PaquetesFleteImportes[], cantSobres: number, importesSobres: number, distancia: number): CotizacionGrupo {
    function obtenerItemPaquete(x: PaquetesFleteImportes): CotizacionConcepto {
        return {
            cantidad: x.Cantidad,
            titulo: `Flete paquete ${paqueteToString(x)}`,
            importe: x.Importes!.Flete,
        };
    }

    function obtenerItemSobres(x: models.SobreDocumentacion): CotizacionConcepto {
        return {
            cantidad: x.Cantidad,
            importe: x.Importes!.Flete,
            titulo: "Flete sobre"
        };
    }

    const paq = paquetes.map(obtenerItemPaquete);
    const sob: CotizacionConcepto = {
        cantidad: cantSobres,
        importe: importesSobres,
        titulo: "Sobres",
    };

    return {
        titulo: `Descripción del envío (${distancia} km)`,
        conceptos: cantSobres > 0 ? [...paq, sob] : paq
    };
}

export function obtenerServicios(importes: models.ImportesGuiaDTO, servicios: models.ServiciosAdicionalesGuia): CotizacionGrupo {
    const conceptos: (CotizacionConcepto & { ver: boolean })[] = [
        {
            titulo: "Entrega a domicilio",
            importe: importes.EntregaDomicilio,
            ver: servicios.EntregaDomicilio
        }, {
            titulo: "Recolección a domicilio",
            importe: importes.RecoleccionDomicilio,
            ver: servicios.RecoleccionDomicilio
        }, {
            titulo: "Seguro",
            importe: importes.Seguro,
            ver: importes.Seguro > 0
        }, {
            titulo: "Seguro",
            importe: 0,
            ver: importes.Seguro <= 0
        }, {
            titulo: "Acuse interno",
            importe: importes.Acuse,
            ver: servicios.TipoAcuse == models.TipoAcuse.Interno
        }, {
            titulo: "Acuse externo",
            importe: importes.Acuse,
            ver: servicios.TipoAcuse == models.TipoAcuse.Externo
        }, {
            titulo: "Zona extendida",
            importe: importes.ZonaExtendida,
            ver: servicios.EntregaDomicilio && (importes.ZonaExtendida > 0)
        }, {
            titulo: "Valor factura",
            importe: importes.ValorFactura,
            ver: importes.ValorFactura > 0
        }, {
            titulo: "Servicio especial",
            importe: importes.ServicioEspecial,
            ver: importes.ServicioEspecial > 0
        }, {
            titulo: "Gasto Administrativo",
            importe: importes.ImporteGastoAdministrativo,
            ver: importes.ImporteGastoAdministrativo > 0
        }
    ];

    const tieneServiciosAdicionales = any(conceptos, x => x.ver);

    return {
        titulo: "Servicios adicionales" + (!tieneServiciosAdicionales ? " (ninguno)" : ""),
        conceptos: conceptos.filter(x => x.ver)
    };
} 


// WEBPACK FOOTER //
// ./app/logic/operativa/cotizacion.tsx